import { LocalStorageKey } from '@/constants/storage';

const buildKey = (memberId: number, orgId: string) => `${memberId}_${orgId}`;

const readMap = () => {
  const raw = localStorage.getItem(LocalStorageKey.ASSISTANT_LAST_CONV);
  if (!raw) {
    return {} as Record<string, string>;
  }
  try {
    return JSON.parse(raw) as Record<string, string>;
  } catch {
    return {} as Record<string, string>;
  }
};

export const getLastAssistantConversationId = (
  memberId: number,
  orgId: string
) => {
  return readMap()[buildKey(memberId, orgId)];
};

export const setLastAssistantConversationId = (
  memberId: number,
  orgId: string,
  conversationId: string
) => {
  const next = readMap();
  next[buildKey(memberId, orgId)] = conversationId;
  localStorage.setItem(
    LocalStorageKey.ASSISTANT_LAST_CONV,
    JSON.stringify(next)
  );
};

export const getAssistantFabPos = () => {
  const raw = localStorage.getItem(LocalStorageKey.ASSISTANT_FAB_POS);
  if (!raw) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(raw) as {
      right?: number;
      bottom?: number;
      x?: number;
      y?: number;
    };
    if (typeof parsed.right === 'number' && typeof parsed.bottom === 'number') {
      return { right: parsed.right, bottom: parsed.bottom };
    }
    if (typeof parsed.x === 'number' && typeof parsed.y === 'number') {
      return {
        right: window.innerWidth - parsed.x - 64,
        bottom: window.innerHeight - parsed.y - 64,
      };
    }
    return undefined;
  } catch {
    return undefined;
  }
};

export const setAssistantFabPos = (pos: { right: number; bottom: number }) => {
  localStorage.setItem(LocalStorageKey.ASSISTANT_FAB_POS, JSON.stringify(pos));
};

export const getAssistantChatSize = () => {
  const raw = localStorage.getItem(LocalStorageKey.ASSISTANT_CHAT_SIZE);
  if (!raw) {
    return undefined;
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed === 'object' &&
      'width' in parsed &&
      'height' in parsed &&
      typeof parsed.width === 'number' &&
      typeof parsed.height === 'number'
    ) {
      return { width: parsed.width, height: parsed.height };
    }
    return undefined;
  } catch {
    return undefined;
  }
};

export const setAssistantChatSize = (size: {
  width: number;
  height: number;
}) => {
  localStorage.setItem(
    LocalStorageKey.ASSISTANT_CHAT_SIZE,
    JSON.stringify(size)
  );
};

export const clearAllAssistantConversationIds = () => {
  localStorage.removeItem(LocalStorageKey.ASSISTANT_LAST_CONV);
};
